import bale from "../../images/balenew.png";
import email from "../../images/email.png";
import instagram from "../../images/instagram.jpg";
import phone from "../../images/phone.png";
import telegram from "../../images/telegram (1) (1).svg";

const ICONS = { phone, instagram, telegram, email, bale };

const hrefFor = (way) => {
  switch (way.type) {
    case "phone":
      return `tel:${way.details}`;
    case "email":
      return `mailto:${way.details}`;
    case "telegram":
      return `https://t.me/${way.details}`;
    case "instagram":
      return `https://www.instagram.com/${way.details}`;
    default:
      return "#";
  }
};

const ActorContact = ({ communication, ways = [] }) => {
  if (!communication && ways.length === 0) return null;

  return (
    <div>
      <h2 className="mb-4 text-2xl font-bold">راه ارتباطی</h2>
      {communication && <p>{communication}</p>}
      <ul>
        {ways.map((way, index) => (
          <li key={`${way.type}-${index}`}>
            <a href={hrefFor(way)} target="_blank" rel="noopener noreferrer">
              {ICONS[way.type] && (
                <img
                  className="inline-block w-6 rounded pb-2"
                  src={ICONS[way.type]}
                  alt={`${way.type} logo`}
                />
              )}
              <span className="inline-block pt-4" dir="ltr">
                {way.details}
              </span>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ActorContact;
